import React from 'react';
import Typography from '@/components/primitives/typography';
import styles from './styles.module.scss';
import Textarea from '@/components/primitives/textarea';

interface Props {
  className?: string;
  caption: string;
  placeholder?: string;
  readOnly?: boolean;
  maxLength?: number;
  label?: string; // 라벨 텍스트 (기본: 캡션)
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

/**
 * Component for caption input
 */
const CaptionInput = (props: Props) => {
  const {
    className = '',
    caption,
    onChange,
    maxLength = 500,
    readOnly = false,
    label = '캡션',
    placeholder = '어떤 이야기를 나누고 싶으신가요?'
  } = props;
  const count = caption?.length ?? 0;
  const overLimit = maxLength ? count > maxLength : false;

  return (
    <div className={`${styles.container} ${className}`}>
      {label ? <Typography size="small" weight="bold">{label}</Typography> : ''}
      <Textarea
        autoFocus={true}
        maxLength={maxLength}
        placeholder={placeholder}
        value={caption}
        onChange={onChange}
        onKeyDown={props.onKeyDown}
        readOnly={readOnly}
      />
      <Typography className={`${styles.counter} ${overLimit ? styles.counterOverLimit : styles.counterNormal}`}>
        {count} / {maxLength}
      </Typography>
    </div>
  );
};

export default CaptionInput;